import { styled } from '@material-ui/core/styles';
import { Tab } from '@material-ui/core';
import TooltipOne from '../../TooltipOne/TooltipOne.component';

export const StyledTab = styled((props) =>
  props.tooltipTitle ? (
    <TooltipOne title={props.tooltipTitle} placement="top">
      <Tab disableRipple {...props} />
    </TooltipOne>
  ) : (
    <Tab disableRipple {...props} />
  ),
)(() => ({
  textTransform: 'none',
  fontWeight: 400,
  color: '#2C2D3E',
  textAlign: 'left',
  padding: '6px 10px 6px 0',
  '& .MuiTab-wrapper': {
    alignItems: 'start',
    padding: '7px 11px',
  },
  '&:hover': {
    color: '#3C419A',
    fontWeight: 400,
    outline: 'none',
    '& .MuiTab-wrapper': {
      background: 'rgba(202, 202, 252, 0.3)',
      borderRadius: '5px',
      alignItems: 'start',
    },
  },
  '&:focus-visible': {
    outline: 'none',
    '& .MuiTab-wrapper': {
      outline: '1px solid black',
      borderRadius: '5px',
      alignItems: 'start',
    },
  },
  '&.Mui-selected': {
    textAlign: 'left',
    color: '#3C419A',
    fontWeight: 'bold',
    '& .MuiTab-wrapper': {
      background: 'rgba(202, 202, 252, 0.3)',
      borderRadius: '5px',
      alignItems: 'start',
    },
    '&:focus-visible': {
      outline: 'none',
      '& .MuiTab-wrapper': {
        background: 'rgba(202, 202, 252, 0.3)',
        borderRadius: '5px',
        alignItems: 'start',
      },
    },
  },
  '& .MuiTabs-indicator': {
    height: 0,
    width: 0,
  },
  width: '95%',
  marginLeft: '5px',
}));
